import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastService } from '@shared/events/toast.service';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { CargarReciboComponent } from '@shared/seguridad/cargar-recibo/cargar-recibo.component';
import { Verification } from './types/subscripcion.interface';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged, tap } from 'rxjs/operators';
import { Bancos, InformacionPagoTranferencia } from '@pages/cuenta/suscripcion/models/facturacion.interface';

@Injectable({
  providedIn: 'root',
})
export class SubscripcionService {
  private _hasActiveSubscription = new BehaviorSubject<boolean>(false);
  readonly hasActiveSubscription$ = this._hasActiveSubscription
    .asObservable()
    .pipe(distinctUntilChanged());

  firstSub = false;
  modalOpen = false;

  constructor(
    private _http: HttpClient,
    private _modalCtrl: ModalController,
    private _router: Router,
    private _toastService: ToastService
  ) {}

  get hasActiveSubscription() {
    return this._hasActiveSubscription.value;
  }

  set hasActiveSubscription(active: boolean) {
    this._hasActiveSubscription.next(active);
  }

  VerificarSubscripcion() {
    this.getSubscripcion().subscribe(async (data) => {
      this.firstSub = data.verification;
      if (!data.verification) {
        this._toastService.toastError(
          'No hay una subscripción activa',
          'Por favor haga el pago'
        );
        if (data.metodo === 2) {
          if (!this.modalOpen) {
            this.modalOpen = true;
            const modal = await this._modalCtrl.create({
              backdropDismiss: false,
              cssClass: 'auto-height',
              component: CargarReciboComponent,
              componentProps: {
                canClose: false,
                type: 1,
              },
            });
            await modal.present();
          }
        } else {
          // this._router.navigate(['/renew']);
          this._router.navigate(['/cuenta/suscripcion/metodos']);
        }
      }
    });
  }

  getSubscripcion() {
    return this._http
      .get<Verification>(`${environment.API_URL}/Subscripcion/Verificar`)
      .pipe(tap((resp) => (this.hasActiveSubscription = resp.verification)));
  }

  getSubscripcionEstablecimientos() {
    return this._http.get<any>(
      `${environment.API_URL}/Subscripcion/Establecimientos`
    );
  }

  getSubscripcionPuntosEmision() {
    return this._http.get<boolean>(
      `${environment.API_URL}/Subscripcion/PuntosEmision`
    );
  }
  getSubscripcionInventarioPro() {
    return this._http.get<boolean>(
      `${environment.API_URL}/Subscripcion/DisponibilidadAddons/InventarioPro`
    );
  }

  getBancos() {
    return this._http.get<Bancos[]>(
      `${environment.API_URL}/PagosPreferidos/Bancos`
    );
  }

  getInformacionPagoTransferencia() {
    return this._http.get<InformacionPagoTranferencia>(
      `${environment.API_URL}/PagosPreferidos/InformacionPagoTransferencia`
    );
  }
}
